// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"fb4e7acc","456":"11611633","656":"f739f945","756":"b956d4e2","968":"cc296193"}[chunkId] + ".chunk.js";
};